if (!customElements.get('wlsn-buybox')) {
    class WLSNBuybox extends HTMLElement {
        constructor() {
            super();

            this.classes = {
                option: 'js-wlsn-product-option',
                activeClass: 'is-active'
            };

            this.elements = {
                options: this.querySelectorAll(`.${this.classes.option}`),
                variantInput: this.querySelector('input[name="id"]')
            };

            const variantMapElement = document.getElementById('wlsn-variant-map');

            this.variantMap = variantMapElement
                ? JSON.parse(variantMapElement.textContent)
                : {};

            this.swiper = this.querySelector('.js-wlsn-slider')?.swiper;
        }

        connectedCallback() {
            this.bindOptionClicks();
            this.activateFirstOption();
            this.bindVideoEvents();
        }

        activateFirstOption() {
            if (this.elements.options.length > 0) {
                this.setActiveOption(this.elements.options[0]);
            }
        }

        bindOptionClicks() {
            this.elements.options.forEach(option => {
                option.addEventListener('click', () => this.setActiveOption(option));
            });
        }

        setActiveOption(option) {
            this.elements.options.forEach(opt => opt.classList.remove(this.classes.activeClass));
            option.classList.add(this.classes.activeClass);

            const denomination = option.dataset.denomination;
            const newVariant = this.variantMap[denomination];

            if (this.elements.variantInput && newVariant?.id) {
                this.elements.variantInput.value = newVariant.id;
            }

            if (this.swiper && newVariant?.media_id) {

                const slides = [...this.querySelectorAll('.wlsn-buybox__slide')];

                const targetIndex = slides.findIndex(slide =>
                    slide.dataset.mediaId == newVariant.media_id
                );

                if (targetIndex >= 0) {
                    this.swiper.slideTo(targetIndex);
                }
            }
        }

        bindVideoEvents() {
            if (!this.swiper) return;
        
            this.querySelectorAll('video').forEach(video => {
                video.addEventListener('play', () => {
                    this.swiper.allowTouchMove = false;
                });
        
                const enableSwipe = () => {
                    this.swiper.allowTouchMove = true;
                };
        
                video.addEventListener('pause', enableSwipe);
                video.addEventListener('ended', enableSwipe);
            });
        }
    }

    customElements.define('wlsn-buybox', WLSNBuybox);
}
